var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNbFeatures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15,
    fill: "#713FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.617 20.617C20.524 20.71 20.4215 20.782 20.3096 20.8329C20.1976 20.8838 20.0707 20.9081 19.9288 20.9057L10.529 20.7169C10.2442 20.7112 10.002 20.6086 9.80249 20.4091C9.60297 20.2096 9.50011 19.9672 9.49391 19.6818C9.48819 19.397 9.57837 19.1615 9.76445 18.9754C9.95053 18.7894 10.186 18.6992 10.4708 18.7049L17.4494 18.845L9.31374 10.7093C9.10793 10.5035 9.00542 10.267 9.00623 9.99989C9.00703 9.73274 9.10605 9.50054 9.3033 9.3033C9.50101 9.10559 9.73635 9.00923 10.0093 9.01424C10.2823 9.01925 10.5217 9.12513 10.7275 9.3319L18.845 17.4494L18.7049 10.4708C18.6992 10.186 18.7894 9.95053 18.9754 9.76445C19.1615 9.57837 19.397 9.48819 19.6818 9.49391C19.9667 9.49963 20.2091 9.60249 20.4091 9.80249C20.6091 10.0025 20.7117 10.2447 20.7169 10.529L20.9057 19.9288C20.9086 20.0712 20.8845 20.1984 20.8336 20.3103C20.7827 20.4222 20.7105 20.5244 20.617 20.617Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbFeatures);
export default __webpack_public_path__ + "static/media/nb_features.6eba66f40b6c466e445a35ad07e5a0c7.svg";
export { ForwardRef as ReactComponent };